import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useActiveStore = create(
  persist(
    (set) => ({
      activeStatus: null,
      setActiveStatus: (activeStatus: any) =>
        set({ activeStatus: activeStatus }),
    }),
    {
      name: "active-status-storage",
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);
